import { Button } from "@mui/material";
import { GridRenderCellParams, GridColDef } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { changeDefaultAccount } from "../Account/AccountUtil";
import DataGridTamplet from "../Helper/TableTemplet/DataGridTamplet";
import { getAccountDetailsList } from "./AdministratorUtils";

const Administrator = () => {
  const accounts = useSelector((state: any) => state.account.account_list);
  const navigate = useNavigate();
  const [isShowcolum, setisShowcolum] = useState({
    thirty: false,
    sixty: true,
    ninety: true,
  });

  let analystsList = useSelector((state: any) => state.user.anylysts_list);
  const dispatch = useDispatch();
  const loginAsAccount = (account_id) => {
    let account = accounts.find((item) => item.id === account_id);
    changeDefaultAccount(dispatch, account);
    navigate("/layout");
  };

  const columns: GridColDef[] = [
    {
      field: "account_name",
      sortable: false,
      headerName: "Account Name",
      width: 140,
    },
    {
      field: "analyst_name",
      headerName: "Analist Name",
      sortable: false,
      width: 140,
    },
    {
      field: "alerts",
      headerName: "Alert",
      width: 100,
    },
    {
      field: "potential_cases",
      headerName: "Potential Cases",
      width: 150,
    },
    {
      field: "potential_value",
      headerName: "Potential Value",
      width: 150,
      valueFormatter: ({ value }) => value && value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    {
      field: "count_thirty",
      headerName: "Cases Opened",
      width: 165,
      hide: isShowcolum["thirty"],
    },
    {
      field: "sum_thirty",
      headerName: "Reimbursed Value",
      hide: isShowcolum["thirty"],
      width: 165,
      type: "number"
    },
    {
      field: "count_sixty",
      headerName: "Cases Opened",
      hide: isShowcolum["sixty"],
      width: 165,
    },
    {
      field: "sum_sixty",
      headerName: "Reimbursed Value",
      hide: isShowcolum["sixty"],
      width: 195,
      type: "number",
      valueFormatter: ({ value }) => value && value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    {
      field: "count_ninety",
      headerName: "Cases Opened",
      hide: isShowcolum["ninety"],
      width: 150,
    },
    {
      field: "sum_ninety",
      headerName: "Reimbursed Value",
      hide: isShowcolum["ninety"],
      width: 195,
      type: "number"
    },
    {
      field: "amount_to_charge",
      headerName: "Amount To Charge",
      width: 170,
      type: "number",
      valueFormatter: ({ value }) => value && value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    {
      field: "view_account",
      headerName: "View Account",
      width: 140,
      renderCell: (params: GridRenderCellParams) => (
        <strong>
          {params.row.status === "Y" && (
            <div
              onClick={() => loginAsAccount(params.row.id)}
              style={{ color: "#3f51b5", cursor: "pointer" }}
            >
              View Account
            </div>
          )}
        </strong>
      ),
    },
  ];

  const textFieldLabel = "Search by Account or Analyst Name";

  let accountDetailsList = useSelector(
    (state: any) => state.account.account_details_list
  );

  let filters = [
    {
      id: "analyst",
      name: "Analyst Name",
      values: analystsList.map((analyst) => {
        return { value: analyst.id, label: analyst.label };
      }),
    },
    {
      id: "history",
      name: "History",
      values: [
        { value: "thirty", label: "30 day" },
        { value: "sixty", label: "60 day" },
        { value: "ninety", label: "90 day" },
      ],
    },
  ];

  const [filtersValues, setFiltersValues] = useState({ analyst: "", history: "thirty", fieldText: "" });

  const search = (list, inputValue) => {
    var filteredCases;
    filteredCases =
      filtersValues["analyst"] != ""
        ? list.filter((item) => item.user_id === filtersValues["analyst"])
        : list;
    if (filtersValues["history"] != "") {
      Object.keys(isShowcolum).forEach((key) => (isShowcolum[key] = true));
      setisShowcolum({ ...isShowcolum, [filtersValues["history"]]: false });
    }
    return autotomaticSearch(filteredCases, inputValue);
  };

  const autotomaticSearch = (list, value) => {
    var filteredCases =
      value != ""
        ? list.filter(
          (item) =>
            (item.account_name && item.account_name.startsWith(value)) ||
            (item.analyst_name && item.analyst_name.startsWith(value))
        )
        : list;
    return filteredCases;
  };

  useEffect(() => {
    getAccountDetailsList(dispatch);
  }, []);

  return (
    <div>
      <h2>View Status</h2>
      <DataGridTamplet
        columns={columns}
        rows={accountDetailsList}
        filters={filters}
        textFieldLabel={textFieldLabel}
        selectedFiltersValues={filtersValues}
        onSearch={search}
        setSelectedFiltersValues={setFiltersValues}
      />
    </div>
  );
};
export default Administrator;
